import {AnalysisTemplateSelectorTemplate} from 'analysis-tool/graphql/AnalysisTemplateSelectorQuery';
import {isDomainConfigVariable} from 'analysis-tool/templates/AnalysisTemplateVariableUtils';

/**
 * Check if a variable should be shown in <AnalysisTemplateVariablesForm>.
 *
 * Folder variables are hidden, because a folder selector is separately shown for the Analysis as a whole.
 *
 * `sectionIndex` is hidden, because it could be confusing to expose directly to users.
 */
export default function shouldShowVariableInForm(
  variable: Pick<
    AnalysisTemplateSelectorTemplate['configVariables'][number],
    'configVariableKey' | 'variableTypeConfigSpec'
  >
): boolean {
  return !isDomainConfigVariable(variable, 'FOLDER') && variable.configVariableKey !== 'sectionIndex';
}
